module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dn-dialog', {
    ref: "dialog",
    attrs: {
      "content-class": "dn-alert-dialog",
      "system": ""
    },
    on: {
      "before-show": _vm.onBeforeShow,
      "before-hide": _vm.onBeforeHide
    }
  }, [(_vm.body) ? _c('p', {
    staticClass: "my-body",
    domProps: {
      "innerHTML": _vm._s(_vm.bodyHtml)
    }
  }) : _vm._e(), _vm._v(" "), _c('template', {
    slot: "footer"
  }, [_c('div', {
    staticClass: "my-btns"
  }, [_c('dn-btn', {
    ref: "ok",
    staticClass: "my-btn",
    on: {
      "click": _vm.ok
    }
  }, [_vm._v(_vm._s(_vm.okLabel))])], 1)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-386912f4","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/ui/components/dialogs/AlertDialog.vue
// module id = 302
// module chunks = 1